import React, { useEffect, useState, Fragment } from 'react';

import { disableHTMLOverflow } from '../../../../Functions';
import { withCookies } from 'react-cookie';
import Traductor from '../../../Traductor';

function TicketCard(card) {
    const t = new Traductor();
    useEffect(() => {
        disableHTMLOverflow(true);
        window.bronson.ComponentRegister.initAll();
        if (document.body.clientWidth <= 768)
            window.bronson.$$('.js-accordion').component('accordion');
    }, []);

    const accordionRender = () => {
        if (window.innerWidth < 720) {
            setTimeout(function () {
                window.bronson.ComponentRegister.initAll();
            }, 0);
            return 'c-accordion  js-accordion  js-is-fx';
        } else {
            return '';
        }
    };

    const closeModal = () => {
        disableHTMLOverflow(false);
        card.closeTicket();
    };

    const ViewResolucion = () => {
        if (card.card.Resolucion === '' || card.card.Resolucion === null)
            return null;
        return (
            <Fragment>
                <hr className="c-hr_ticket" />
                <header className="c-modal__header u-detail_title_Resolucion">
                    <div className="c-modal__title__wrapper u-detail_title">
                        <h4 className="u-h4 c-modal__title">
                            <strong className="u-detail_title_amount">
                                {t.getTraduction('Resolucion')}
                            </strong>
                        </h4>
                    </div>
                </header>
                <div className="c-card__body u-p u-pb-none u-margin_resolucion">
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-mt-mini">
                            <p className="u-text-disabled u-mb-none skeleton-title">
                                {t.getTraduction('DateEnd')}
                            </p>
                            <p className="skeleton-body">{card.card.DateEnd}</p>
                        </div>
                        <div className="o-layout__item u-1/1 u-mt-mini">
                            <p className="skeleton-body u-ticket_Resolution">
                                {card.card.Resolucion}
                            </p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };
    return (
        <div
            className="c-modal c-modal--left c-modal--advanced-filters js-modal--advanced-filter c-vehicle-filters--advanced c-ticket_modal"
            aria-hidden="false"
            id="demo-modal"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className={`c-modal__wrapper  ${
                    card.card.Resolucion === '' || card.card.Resolucion === null
                        ? card.classExtra
                        : 'c-detail_modal_ticket_wrapper_with_resolution'
                }`}
                role="dialog"
            >
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper u-detail_title">
                        <h1 className="u-detail_title_amount_H1">
                            <strong className="u-detail_title_amount">
                                {t.getTraduction('TicketTitle') +
                                    ' ' +
                                    card.card.IdTicket}
                            </strong>
                            <label className="u-detail_title_status">
                                {' '}
                                {card.FormatStatus(card.card.Status)}{' '}
                            </label>
                        </h1>
                    </div>
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        onClick={closeModal}
                        type="button"
                        aria-label="Cerrar modal."
                    ></button>
                </header>
                <div className={`c-modal__content `}>
                    <div className={accordionRender()}>
                        {/*body*/}
                        <div className="c-card__body u-p u-pb-none">
                            <div className="o-layout">
                                <div className="o-layout__item u-1/3 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('Plate')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.Plate}
                                    </p>
                                </div>

                                <div className="o-layout__item u-1/3 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('TicketCreationDate')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.Date}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/3 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('OpFinanciera')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.OpFinan}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/3 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('Concesionario')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.Conces}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/3 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('Solictante')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.Solicitante}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <hr className="c-hr_detail_ticket" />

                        {/*body*/}
                        <div className="c-card__body u-p u-pb-none c-card_margin_body_ticket">
                            <div className="o-layout">
                                <div className="o-layout__item u-1/1 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('Gestor')}
                                    </p>
                                    <p className="skeleton-body">
                                        <label className="u-detail_ticket_manager">
                                            <strong>{card.card.Gestor}</strong>
                                        </label>
                                        <label className="u-detail_ticket_manager">
                                            <a
                                                href={`mailto: ${card.card.EmailGestor}`}
                                            >
                                                <i
                                                    className="c-icon  c-icon--xsmall js-tooltip c-tooltip c-icon--[email] c-tooltip_ticket_label_phone "
                                                    data-template={
                                                        card.card.EmailGestor
                                                    }
                                                    data-tippy-content={
                                                        card.card.EmailGestor ||
                                                        'NO ENCONTRADO'
                                                    }
                                                    data-tippy-placement="top"
                                                />
                                            </a>
                                        </label>
                                    </p>
                                </div>

                                <div className="o-layout__item u-1/1 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('TicketType')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.TipoTicket}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/1 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('DescShort')}
                                    </p>
                                    <p className="skeleton-body">
                                        {card.card.DescrShort}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/1 u-mt-mini">
                                    <p className="u-text-disabled u-mb-none skeleton-title">
                                        {t.getTraduction('DescLong')}
                                    </p>
                                    <p className="skeleton-body u-ticket_body_border">
                                        {card.card.DescrLong}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <ViewResolucion />
                        <div className="sg-component-variant c-modal__title__wrapper">
                            <button
                                className="c-btn  c-btn--secondary"
                                onClick={closeModal}
                                type="button"
                                aria-label="Cerrar modal."
                            >
                                <span className="c-btn__text">
                                    {t.getTraduction('Close')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="c-modal__footer c-advanced-filters__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item"></div>
                        <div className="c-modal__actions__item"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withCookies(TicketCard);
